// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__2disq","forms":"Login_forms__BpHWv"};